import { render } from "./ingredients.vue?vue&type=template&id=30bcf138&scoped=true&ts=true"
import script from "./ingredients.vue?vue&type=script&lang=ts"
export * from "./ingredients.vue?vue&type=script&lang=ts"

import "./ingredients.vue?vue&type=style&index=0&id=30bcf138&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bcf138"]])

export default __exports__